/*
 * @Author: zhang lin
 * @Date: 2022-04-07 13:22:27
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-14 09:32:31
 * @Description: file content
 */
import React, { useState, useEffect } from 'react';
import styles from './index.less';
import { Checkbox, Button } from 'sup-ui';
import Modal from 'root/components/CommonModal';
import messages from 'root/pages/InstallSupos/messages';
import { useIntl } from 'react-intl';
import { packAgreement } from 'root/services/packageManage';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

interface PropsType {
  stepAdd: Function;
  cancelFn: ((e: React.MouseEvent<any, MouseEvent>) => void) | undefined;
  supOSConfigData: any;
}

const License = (props: PropsType) => {
  const intl = useIntl();

  const { stepAdd, cancelFn, supOSConfigData } = props;
  const [licenseChecked, setLicenseChecked] = useState(false);
  const { systemInfo } = useSelector((state: reducerStates) => state.fileConfig);
  const [agreementHtml, setAgreementHtml] = useState<string>('');

  // 点击复选框
  const changeLicenseCheckbox = () => {
    setLicenseChecked(!licenseChecked);
  };
  // 点击安装按钮
  const handleInstalll = () => {
    if (licenseChecked) {
      stepAdd();
    }
  };
  useEffect(() => {
    getPackAgreement();
    if (supOSConfigData.supos.mem) {
      setLicenseChecked(true);
    }
  }, []);

  // 获取安装包协议内容
  const getPackAgreement = () => {
    packAgreement(systemInfo?.archiveId).then((res: any) => {
      setAgreementHtml(res.data);
    });
  };

  return (
    <Modal
      className={styles.license}
      visible={true}
      width="640px"
      onCancel={cancelFn}
      title={<h4 className={styles.licenseTitle}>{intl.formatMessage(messages.lincenseTitle)}</h4>}
      footer={
        <div className={styles.bottom}>
          <span onClick={changeLicenseCheckbox}>
            <Checkbox checked={licenseChecked} />
            <span className={styles.bottomText}> {intl.formatMessage(messages.readingAgreement)}</span>
          </span>
          <div className={styles.btnBox}>
            <Button type="primary" onClick={handleInstalll} disabled={!licenseChecked}>
              {intl.formatMessage(messages.install)}
            </Button>
            &nbsp;&nbsp;
            <Button onClick={cancelFn}> {intl.formatMessage(messages.cancelText)}</Button>
          </div>
        </div>
      }
    >
      <div className={styles.licenseContent} dangerouslySetInnerHTML={{ __html: agreementHtml }} />
    </Modal>
  );
};
export default License;
